import React from "react";
import { EnrollmentReview } from "../../../containers";

const EnrollmentReviewReport = (props) => {
  return <EnrollmentReview {...props} />;
};

export default EnrollmentReviewReport;
